// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 15 15" {...rest} unit={unit}>
		<g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g id="GameplayComponent/Key-Mobile" transform="translate(-20.000000, -265.000000)"
				fill="#F6DC03" fillRule="nonzero">
				<g id="2" transform="translate(0.000000, 171.000000)">
					<g id="Favourite" transform="translate(20.000000, 94.000000)">
						<g id="UI/Icon/Yellow/Star">
							<polygon id="Shape"
								points="7.5 11.82895 2.86474508 14.2658477 3.75 9.10441554
								1.66533454e-16 5.44906896 5.18237254 4.69602615
								7.5 0 9.81762746 4.69602615 15 5.44906896 11.25 9.10441554
								12.1352549 14.2658477" />
						</g>
					</g>
				</g>
			</g>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Favorite.js